// https://vuex.vuejs.org/en/getters.html

export default {
  types(state) {
    return state.iron_types;
  },
  errors(state) {
    return state.errors;
  },
  loading(state) {
    return state.loading;
  },
  totalCount(state) {
    return state.totalCount;
  }
};
